export * from './administration.service';
import { AdministrationService } from './administration.service';
export * from './administration.serviceInterface';
export * from './b2BPortal.service';
import { B2BPortalService } from './b2BPortal.service';
export * from './b2BPortal.serviceInterface';
export * from './company.service';
import { CompanyService } from './company.service';
export * from './company.serviceInterface';
export * from './companyCompanyProfile.service';
import { CompanyCompanyProfileService } from './companyCompanyProfile.service';
export * from './companyCompanyProfile.serviceInterface';
export * from './companyProfileV3.service';
import { CompanyProfileV3Service } from './companyProfileV3.service';
export * from './companyProfileV3.serviceInterface';
export * from './global.service';
import { GlobalService } from './global.service';
export * from './global.serviceInterface';
export * from './internalProductName.service';
import { InternalProductNameService } from './internalProductName.service';
export * from './internalProductName.serviceInterface';
export * from './miscellaneous.service';
import { MiscellaneousService } from './miscellaneous.service';
export * from './miscellaneous.serviceInterface';
export * from './offer.service';
import { OfferService } from './offer.service';
export * from './offer.serviceInterface';
export * from './payment.service';
import { PaymentService } from './payment.service';
export * from './payment.serviceInterface';
export * from './reseller.service';
import { ResellerService } from './reseller.service';
export * from './reseller.serviceInterface';
export * from './stellenanzeigenServices.service';
import { StellenanzeigenServicesService } from './stellenanzeigenServices.service';
export * from './stellenanzeigenServices.serviceInterface';
export * from './synchronization.service';
import { SynchronizationService } from './synchronization.service';
export * from './synchronization.serviceInterface';
export * from './user.service';
import { UserService } from './user.service';
export * from './user.serviceInterface';
export const APIS = [AdministrationService, B2BPortalService, CompanyService, CompanyCompanyProfileService, CompanyProfileV3Service, GlobalService, InternalProductNameService, MiscellaneousService, OfferService, PaymentService, ResellerService, StellenanzeigenServicesService, SynchronizationService, UserService];
